import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import MultiSelect from "shared/react_components/MultiSelect";
import classNames from "classnames";

const MultiSelectDropdown = ({ ...props }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = useCallback(() => setDropdownOpen(val => !val), []);
  let label;
  if (props.options.length === props.selectedOptions.length && props.isMulti && props.options.length !== 0) {
    label = "All selected";
  } else if (props.selectedOptions.length > 1) {
    label = `${props.selectedOptions.length} selected`;
  } else if (props.selectedOptions.length === 1) {
    label = props.selectedOptions[0].label;
  } else {
    label = "None selected";
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} disabled={props.isDisabled} className={props.className}>
      <DropdownToggle caret size="md" className={classNames("d-inline-flex justify-content-between align-items-center w-100", props.className)}>
        <span className="text-truncate">
          {label}
        </span>
      </DropdownToggle>
      <DropdownMenu flip={false} className={props.className}>
        <div className="m-2">
          <MultiSelect {...props}/>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

MultiSelectDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  isMulti: PropTypes.bool,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};

MultiSelectDropdown.defaultProps = {
  isMulti: true,
  isDisabled: false
};

export default MultiSelectDropdown;
